import React, { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import { useLanguage } from '../contexts/LanguageContext';

export function profileForm(profile, user, name) {
  return {
    firstName: profile?.firstName || '', lastName: profile?.lastName || '',
    username: profile?.username || name, email: profile?.email || user?.email || '',
    phoneNumber: profile?.phoneNumber || '', profileLocation: profile?.profileLocation || '',
    linkedin: profile?.linkedin || '', portfolioURL: profile?.portfolioURL || profile?.portfolioUrl || '',
    openToWork: profile?.openToWork === true,
  };
}

export default function ProfileEditor({ initialValues, onSave, onClose, initialFocusField = 'firstName' }) {
  const { language, t } = useLanguage();
  const tp = (key) => t(`profilePage.${key}`);
  const [form, setForm] = useState(initialValues);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const dialog = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    element.showModal(); document.body.style.overflow = 'hidden';
    element.querySelector(`[name="${initialFocusField}"]`)?.focus();
    return () => { element.close(); document.body.style.overflow = overflow; if (previous?.isConnected) previous.focus(); };
  }, [initialFocusField]);
  const save = async (event) => {
    event.preventDefault(); if (saving || !onSave) return;
    setSaving(true); setError('');
    try { await onSave(form); onClose(); }
    catch (failure) { setError(language === 'ar' ? 'تعذّر حفظ التغييرات. حاول مجدداً.' : failure.message || 'Could not save your changes. Please try again.'); }
    finally { setSaving(false); }
  };
  const fields = [['firstName', tp('firstName')], ['lastName', tp('lastName')], ['email', tp('email'), 'email'], ['phoneNumber', tp('phone'), 'tel'], ['profileLocation', tp('location')], ['linkedin', 'LinkedIn'], ['portfolioURL', tp('portfolio')]];
  return createPortal(<dialog ref={dialog} className="js-profile-edit-dialog" aria-labelledby={titleId} dir={language === 'ar' ? 'rtl' : 'ltr'} onCancel={(event) => { event.preventDefault(); if (!saving) onClose(); }}>
    <header><h2 id={titleId}>{tp('editLabel')}</h2><button type="button" onClick={onClose} disabled={saving} aria-label={tp('cancel')}><FiX /></button></header>
    <form onSubmit={save} aria-label={tp('editLabel')}>
      <div className="js-profile-edit-dialog__fields">{fields.map(([field, label, type]) => <label key={field}><span>{label}</span><input name={field} type={type || 'text'} dir={['email', 'phoneNumber', 'linkedin', 'portfolioURL'].includes(field) ? 'ltr' : 'auto'} value={form[field]} disabled={saving} onChange={(e) => setForm((current) => ({ ...current, [field]: e.target.value }))} /></label>)}</div>
      <label className="js-profile-edit-dialog__availability"><input type="checkbox" checked={form.openToWork} disabled={saving} onChange={(e) => setForm((current) => ({ ...current, openToWork: e.target.checked }))} /><span>{tp('openToWork')}</span></label>
      {error && <p role="alert">{error}</p>}
      <footer><button type="button" onClick={onClose} disabled={saving}>{tp('cancel')}</button><button type="submit" disabled={saving || !onSave}>{saving ? tp('saving') : tp('save')}</button></footer>
    </form>
  </dialog>, document.body);
}
